/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { DSBackdrop } from '@elliemae/ds-backdrop';
import { Close } from '@elliemae/ds-icons';
import { DSIconSizes, DSIconColors } from '@elliemae/ds-icon';
import { PropTypes, describe } from '@elliemae/ds-props-helpers';
import { noop } from 'lodash-es';
import { SvgIcon as Logo } from '../Icons/EM_logo.js';
import { Container, Menu, Heading, Icon, Hr, MenuList, BottomMenu, MenuWrapper } from './styles.js';

const DSSideNav = ({ containerProps = {}, title, onClose = noop, menuItems = [], bottomMenuItems = [] }) => {
  const [selectedMenuItemIdx, setSelectedMenuItem] = useState(-1);

  const menuItemClick = (idx, text, cb) => {
    if (cb) {
      cb(idx, text);
    }
    setSelectedMenuItem(idx);
  };

  const renderMenuList = () => (
    <>
      {menuItems.length > 0 ? (
        <MenuList>
          {menuItems.map(({ icon, text, onClick }, idx) => (
            <div key={idx} className="menuitem" onClick={menuItemClick.bind(null, idx, text, onClick)}>
              <div className="icon">{icon}</div>
              <div className={`text ${idx === selectedMenuItemIdx ? 'active' : ''}`}>{text}</div>
            </div>
          ))}
        </MenuList>
      ) : null}
    </>
  );

  const renderBottomMenu = () => (
    <MenuList>
      {bottomMenuItems.map(({ icon, text, onClick }, idx) => (
        <div key={idx} className="menuitem" onClick={() => onClick(idx, text)}>
          <div className="icon">{icon}</div>
          <div className="text">{text}</div>
        </div>
      ))}
    </MenuList>
  );

  return (
    <Container data-testid={containerProps['data-testid'] || 'global-header-menu'}>
      <DSBackdrop onClick={onClose} type="cover"></DSBackdrop>

      <Menu>
        <MenuWrapper>
          <Heading>
            <Icon>{Logo()}</Icon>
            <div className="content">
              <label>{title}</label>
              <span></span>
              <div className="icon">
                <Close onClick={onClose} size={DSIconSizes.S} color={DSIconColors.WHITE} />
              </div>
            </div>
          </Heading>
          <Hr></Hr>
          {renderMenuList()}
          {bottomMenuItems.length > 0 ? (
            <BottomMenu>
              <div className="content">
                <hr></hr>
                {renderBottomMenu()}
              </div>
            </BottomMenu>
          ) : null}
        </MenuWrapper>
      </Menu>
    </Container>
  );
};

const menuProps = PropTypes.arrayOf(
  PropTypes.shape({
    icon: PropTypes.element,
    text: PropTypes.string,
  }),
);

const navProps = {
  /** inject props to wrapper element of side nav */
  containerProps: PropTypes.object.description('inject props to wrapper element of side nav'),
  /**
   * Heading Title
   */
  title: PropTypes.string.isRequired.description('Heading Title'),
  /**
   * Callback function when close is menu is triggered
   */
  onClose: PropTypes.func.description('Callback function when close is menu is triggered'),
  /**
   * Top Menu items array
   */
  menuItems: menuProps.description('Top Menu items array'),
  /**
   * Bottom Menu items array
   */
  bottomMenuItems: menuProps.description('Bottom Menu items array'),
};

DSSideNav.displayName = 'DSSideNav';
const DSSideNavWithSchema = describe(DSSideNav).description('Side navigation for mobile and tablet');

DSSideNavWithSchema.propTypes = navProps;

export { DSSideNav, DSSideNavWithSchema };
